import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
const KIT_URL = 'https://digital-solvex-ar.myshopify.com/cart/48566694772993:1';
// Kit completo hero
const FEATURED_IMG = 'https://cdn.shopify.com/s/files/1/0815/5253/9905/files/A_premium_collection_202604161700.jpg?v=1776373446';
// Individual product cards — NEW Flow Labs images (portrait 2:3)
const PRODUCTS = [{
  img: 'https://cdn.shopify.com/s/files/1/0815/5253/9905/files/A_premium_dark_202604161653.jpg?v=1776373446',
  num: '01',
  badge: 'PRODUCTO PRINCIPAL',
  badgeBg: 'rgba(200,147,42,0.18)',
  badgeColor: '#C8932A',
  badgeBorder: 'rgba(200,147,42,0.4)',
  name: 'Blindaje Profesional ARCA 2026',
  desc: 'La guía definitiva de 8 capítulos para operar con total tranquilidad ante ARCA.',
  features: ['7 pilares del blindaje fiscal profesional', 'Los 5 errores que te ponen en la mira', 'Plan de acción de 30 días + checklist', 'Sistema de 4 sobres para tus finanzas'],
  value: '$79.900',
  accentColor: '#C8932A',
  cardBg: 'rgba(255,255,255,0.03)',
  hoverBg: 'rgba(13,47,79,0.97)',
  hoverBorder: 'rgba(200,147,42,0.4)'
}, {
  img: 'https://cdn.shopify.com/s/files/1/0815/5253/9905/files/A_premium_digital_202604161653.jpg?v=1776373446',
  num: '02',
  badge: 'HERRAMIENTA INCLUIDA',
  badgeBg: 'rgba(30,155,138,0.15)',
  badgeColor: '#1E9B8A',
  badgeBorder: 'rgba(30,155,138,0.35)',
  name: 'Excel Maestro Argentina',
  desc: '6 pestañas automáticas. Solo completás los datos en azul — el resto lo calcula solo.',
  features: ['Dashboard automático de KPIs', 'Semáforo de categoría ARCA', 'Sistema de 4 sobres automático', 'Seguimiento CEDEARs y MEP'],
  value: '$39.900',
  accentColor: '#1E9B8A',
  cardBg: 'rgba(255,255,255,0.03)',
  hoverBg: 'rgba(13,47,79,0.97)',
  hoverBorder: 'rgba(30,155,138,0.4)'
}, {
  img: 'https://cdn.shopify.com/s/files/1/0815/5253/9905/files/A_premium_digital_202604161654_1.jpg?v=1776373446',
  num: '03',
  badge: 'BONO 1 — REGALO',
  badgeBg: 'rgba(255,255,255,0.06)',
  badgeColor: 'rgba(255,255,255,0.55)',
  badgeBorder: 'rgba(255,255,255,0.14)',
  name: 'Guía de Inversión Defensiva',
  desc: 'Dólar MEP en 6 pasos + cartera de CEDEARs recomendada para dolarizar tu ahorro.',
  features: ['Dólar MEP paso a paso con capturas', 'AAPL, NVDA, GOOGL, MSFT, MELI', 'Estrategia de dolarización mensual', 'Comparativo MEP vs Blue vs Oficial'],
  value: '$29.900',
  accentColor: '#C8932A',
  cardBg: 'rgba(255,255,255,0.03)',
  hoverBg: 'rgba(13,47,79,0.97)',
  hoverBorder: 'rgba(200,147,42,0.3)'
}, {
  img: 'https://cdn.shopify.com/s/files/1/0815/5253/9905/files/A_premium_legal_202604161656.jpg?v=1776373446',
  num: '04',
  badge: 'BONO 2 — REGALO',
  badgeBg: 'rgba(255,255,255,0.06)',
  badgeColor: 'rgba(255,255,255,0.55)',
  badgeBorder: 'rgba(255,255,255,0.14)',
  name: 'Kit de Respuesta ARCA',
  desc: '2 modelos de notas legales + protocolo de 5 pasos para responder notificaciones.',
  features: ['Modelo de descargo por acreditaciones', 'Modelo de recategorización voluntaria', 'Los 5 errores que arruinan un descargo', 'Checklist completo de documentación'],
  value: '$29.900',
  accentColor: '#7B93A8',
  cardBg: 'rgba(255,255,255,0.03)',
  hoverBg: 'rgba(13,47,79,0.97)',
  hoverBorder: 'rgba(123,147,168,0.35)'
}, {
  img: 'https://cdn.shopify.com/s/files/1/0815/5253/9905/files/A_premium_online_202604161659.jpg?v=1776373446',
  num: '05',
  badge: 'UPSELL PREMIUM',
  badgeBg: 'rgba(30,155,138,0.15)',
  badgeColor: '#1E9B8A',
  badgeBorder: 'rgba(30,155,138,0.35)',
  name: 'Masterclass Ruta Freelancer Global',
  desc: '6 módulos para cobrar en dólares reales desde Argentina con normativa BCRA 2025.',
  features: ['Normativa BCRA 2025 con ejemplos reales', 'Upwork, Fiverr, LinkedIn, Toptal', 'Cómo cobrar sin perder en el camino', 'Plan de 90 días para tu primer cliente'],
  value: '$99.900',
  accentColor: '#1E9B8A',
  cardBg: 'rgba(255,255,255,0.03)',
  hoverBg: 'rgba(13,47,79,0.97)',
  hoverBorder: 'rgba(30,155,138,0.4)'
}];
export function OfferSection() {
  const [hoveredIdx, setHoveredIdx] = useState<number | null>(null);
  return <section className="bg-navy-dark py-16 md:py-24 px-4 pt-[50px] pb-[50px] space-y-[8px]" data-id="element-159">
      <div className="max-w-5xl mx-auto" data-id="element-160">
        {/* ── HEADER ── */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-161">
          <p className="text-xs font-bold text-teal tracking-widest uppercase mb-3" data-id="element-162">
            Kit Blindaje Total Argentina
          </p>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl text-white leading-[1.1] mb-4" data-id="element-163">
            Todo lo que incluye el kit
          </h2>
          <p className="text-white/45 text-base md:text-lg max-w-md mx-auto" data-id="element-164">
            5 productos profesionales. Acceso inmediato. Sin cuotas. Acceso de
            por vida.
          </p>
        </motion.div>

        {/* ── FEATURED HERO CARD ── */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.65
      }} className="rounded-3xl overflow-hidden mb-5 border border-gold/25" style={{
        background: 'linear-gradient(135deg, #0D2F4F 0%, #07192A 60%, #0A2840 100%)'
      }} data-id="element-165">
          <div className="absolute inset-0 opacity-25 pointer-events-none" style={{
          backgroundImage: 'radial-gradient(rgba(200,147,42,0.12) 1px, transparent 1px)',
          backgroundSize: '22px 22px'
        }} data-id="element-166" />

          {/* Grid: copy left, image right */}
          <div className="relative z-10 grid md:grid-cols-2" data-id="element-167">
            {/* Copy */}
            <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-168">
              <div className="inline-flex items-center gap-2 bg-gold/15 border border-gold/30 rounded-full px-4 py-1.5 mb-5 w-fit" data-id="element-169">
                <span className="w-2 h-2 rounded-full bg-gold animate-pulse flex-shrink-0" data-id="element-170" />
                <span className="text-xs font-extrabold text-gold tracking-widest uppercase" data-id="element-171">
                  La oferta completa
                </span>
              </div>

              <h3 className="font-display text-2xl md:text-3xl lg:text-4xl text-white mb-4 leading-snug" data-id="element-172">
                Los 5 productos
                <br data-id="element-173" />
                <span className="gold-shine" data-id="element-174">por el precio de uno</span>
              </h3>

              <p className="text-white/50 text-sm md:text-base leading-relaxed mb-6" data-id="element-175">
                En lugar de $279.500 por separado, hoy los llevás todos por una
                fracción del precio.
              </p>

              {/* Value stack */}
              <div className="space-y-2 mb-8" data-id="element-176">
                {PRODUCTS.map((p, i) => <div key={i} className="flex items-center justify-between py-1.5 border-b border-white/[0.05]" data-id="element-177">
                    <div className="flex items-center gap-2" data-id="element-178">
                      <Check className="w-3.5 h-3.5 text-teal flex-shrink-0" data-id="element-179" />
                      <span className="text-white/60 text-xs" data-id="element-180">{p.name}</span>
                    </div>
                    <span className="text-white/20 text-xs line-through ml-3 flex-shrink-0" data-id="element-181">
                      {p.value}
                    </span>
                  </div>)}
              </div>

              {/* Price */}
              <div className="flex items-baseline gap-3 mb-5" data-id="element-182">
                <span className="text-white/25 text-sm line-through" data-id="element-183">
                  $279.500
                </span>
                <span className="font-display text-4xl md:text-5xl text-gold leading-none" data-id="element-184">
                  $62.900
                </span>
              </div>

              <a href={KIT_URL} className="btn-gold inline-flex items-center gap-2 font-display text-base md:text-lg px-7 py-4 rounded-xl no-underline w-fit" data-id="element-185">
                Quiero el Kit Completo
                <ArrowRight className="w-5 h-5 flex-shrink-0" data-id="element-186" />
              </a>
            </div>

            {/* Image */}
            <div className="relative overflow-hidden min-h-[260px]" data-id="element-187">
              <img src={FEATURED_IMG} alt="Kit Blindaje Total — los 5 productos" className="absolute inset-0 w-full h-full" style={{
              objectFit: 'cover',
              objectPosition: 'center'
            }} data-id="element-188" />
              <div className="absolute inset-0 bg-gradient-to-r from-[#07192A]/70 via-transparent to-transparent md:from-transparent" data-id="element-189" />
              <div className="absolute top-5 right-5 bg-teal text-white font-extrabold text-xs px-3 py-2 rounded-xl shadow-lg" data-id="element-190">
                Ahorrás $216.600
              </div>
            </div>
          </div>
        </motion.div>

        {/* ── PRODUCT LIST LABEL ── */}
        <p className="text-center text-white/25 text-xs uppercase tracking-widest mb-4 font-semibold" data-id="element-191">
          ¿Qué incluye cada producto?
        </p>

        {/* ── INDIVIDUAL PRODUCT CARDS ── */}
        {/* KEY FIX: image div has alignSelf:'stretch' so it fills 100% of card height.
            The img inside has width:100% height:100% objectFit:cover.
            No absolute positioning — completely reliable across all browsers. */}
        <div className="space-y-3" data-id="element-192">
          {PRODUCTS.map((p, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.07
        }} onHoverStart={() => setHoveredIdx(i)} onHoverEnd={() => setHoveredIdx(null)} className="rounded-2xl overflow-hidden border transition-all duration-300" style={{
          borderColor: hoveredIdx === i ? p.hoverBorder : 'rgba(255,255,255,0.06)',
          background: hoveredIdx === i ? p.hoverBg : p.cardBg
        }} data-id="element-193">
              {/* ── MOBILE IMAGE — full-width banner, only shows on mobile ── */}
              {/* sm:hidden = visible only below 640px */}
              <div className="sm:hidden w-full overflow-hidden relative" style={{
            height: '200px'
          }} data-id="element-194">
                <img src={p.img} alt={p.name} style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center top',
              display: 'block'
            }} data-id="element-195" />
                {/* Bottom gradient */}
                <div className="absolute inset-x-0 bottom-0 h-1/3 pointer-events-none" style={{
              background: 'linear-gradient(to top, rgba(0,0,0,0.5), transparent)'
            }} data-id="element-196" />
              </div>

              {/* ── DESKTOP LAYOUT — row with sidebar image ── */}
              <div className="flex flex-row" style={{
            alignItems: 'stretch'
          }} data-id="element-197">
                {/* Desktop sidebar image — hidden on mobile, visible sm+ */}
                <div className="hidden sm:block flex-shrink-0 overflow-hidden relative" style={{
              width: '168px',
              alignSelf: 'stretch'
            }} data-id="element-198">
                  <img src={p.img} alt={p.name} style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center top',
                display: 'block'
              }} data-id="element-199" />
                  {/* Bottom fade */}
                  <div className="absolute inset-x-0 bottom-0 h-1/4 pointer-events-none" style={{
                background: 'linear-gradient(to top, rgba(0,0,0,0.4), transparent)'
              }} data-id="element-200" />
                </div>

                {/* ── CONTENT COLUMN — always visible ── */}
                <div className="flex-1 p-5 md:p-7" style={{
              minWidth: 0
            }} data-id="element-201">
                  {/* Number pill + Badge row */}
                  <div className="flex items-center gap-2 mb-3 flex-wrap" data-id="element-202">
                    {/* Number moved OUTSIDE the image as a subtle label */}
                    <span className="font-display font-extrabold leading-none" style={{
                  fontSize: 13,
                  color: p.accentColor,
                  opacity: 0.55,
                  letterSpacing: '0.06em'
                }} data-id="element-203">
                      {p.num}
                    </span>
                    <span className="inline-block text-[10px] font-extrabold tracking-wider px-3 py-1 rounded-full border uppercase" style={{
                  background: p.badgeBg,
                  color: p.badgeColor,
                  borderColor: p.badgeBorder
                }} data-id="element-204">
                      {p.badge}
                    </span>
                  </div>

                  <h3 className="font-display text-base md:text-xl text-white mb-2 leading-snug" data-id="element-205">
                    {p.name}
                  </h3>

                  <p className="text-white/45 text-xs md:text-sm leading-relaxed mb-4" data-id="element-206">
                    {p.desc}
                  </p>

                  {/* Features 2-col grid */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1.5 mb-4" data-id="element-207">
                    {p.features.map((f, fi) => <div key={fi} className="flex items-start gap-2" data-id="element-208">
                        <div className="w-3.5 h-3.5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
                    background: p.accentColor + '22'
                  }} data-id="element-209">
                          <Check className="w-2 h-2" style={{
                      color: p.accentColor
                    }} data-id="element-210" />
                        </div>
                        <span className="text-white/50 text-xs leading-relaxed" data-id="element-211">
                          {f}
                        </span>
                      </div>)}
                  </div>

                  {/* Value + INCLUIDO badge */}
                  <div className="flex items-center gap-3 flex-wrap" data-id="element-212">
                    <span className="text-white/20 text-xs line-through" data-id="element-213">
                      Valor: {p.value}
                    </span>
                    <span className="text-[10px] font-extrabold px-3 py-1 rounded-full" style={{
                  background: p.accentColor + '20',
                  color: p.accentColor,
                  border: `1px solid ${p.accentColor}40`
                }} data-id="element-214">
                      INCLUIDO EN EL KIT
                    </span>
                  </div>
                </div>
              </div>
              {/* end desktop row */}
            </motion.div>)}
        </div>

        {/* ── SECTION BOTTOM CTA ── */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-center mt-12" data-id="element-215">
          <a href={KIT_URL} className="btn-gold inline-flex items-center gap-3 font-display text-lg md:text-xl px-10 py-5 rounded-2xl no-underline" data-id="element-216">
            Quiero los 5 productos por $62.900
            <ArrowRight className="w-6 h-6 flex-shrink-0" data-id="element-217" />
          </a>
          <p className="text-white/25 text-sm mt-4" data-id="element-218">
            Descarga inmediata · Acceso de por vida
          </p>
        </motion.div>
      </div>
    </section>;
}